<template>
	<div id="september-new-bonus-promo">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">
			New Subscriber Bonus Promo
		</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					Offer valid for new subscribers only in NSW, VIC, and QLD,
					aged 21+.
				</li>
				<li>
					Promotion runs from 1 September 2026, 12:00 AM AEST to 16
					October 2026, 11:59 PM AEDT.
				</li>
				<li>
					Eligible vehicles are limited to those labeled "NEW BONUS"
					only.
				</li>
				<li>
					Eligible participants must use promo code "NEWBONUS" at
					checkout
				</li>
				<li>
					Availability may vary, and some models might be excluded.
				</li>
				<li>The discount applies only to the upfront fee.</li>
				<li>Subscription must be confirmed by 16 October 2026.</li>
				<li>One promo per person per subscription.</li>
				<li>Swaps not included.</li>
				<li>
					Not valid for fleet vehicles or tools-of-trade subscriptions
					and cannot be combined with other discounts, except for the
					refer-a-friend program.
				</li>
				<li>Standard carbar subscription fees and terms apply.</li>
			</ul>
		</div>
	</div>
</template>
